import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  TimeScale,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import useLineChart from 'helpers/use_line_chart';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  TimeScale,
  Tooltip,
  Legend,
  Filler,
);

type GraphDataPoint = {
  month: string;
  amount: number;
};

type FinancialsWidgetChartProps = {
  data: GraphDataPoint[];
  currency: string;
  chartType: 'netRevenue' | 'mrr';
};

const FinancialsWidgetChart = ({ data, currency, chartType }: FinancialsWidgetChartProps) => {
  // Parse graph data to match useLineChart format
  const parseGraphData = (graphData: GraphDataPoint[]) => {
    return graphData.map((item) => ({
      x: item.month,
      y: item.amount,
    }));
  };

  const chartParams = {
    lineColor: chartType === 'netRevenue' ? '#fad1af' : '#dfebba',
    yFormat: '$,2f',
    fillArea: true,
    lineType: 'monotone' as const,
    currency: [currency, ''] as [string, string],
    margin: { top: 0, left: 0, right: 0, bottom: 5 },
    hideMaxMin: true,
    height: 200,
  };

  const { chartRef, chartData, chartOptions } = useLineChart(
    parseGraphData(data),
    chartParams,
  );

  return (
    <div style={{ height: '200px', width: '100%' }}>
      <Line ref={chartRef} data={chartData} options={chartOptions} />
    </div>
  );
};

export default FinancialsWidgetChart;
